<!-- 创建时间2023/07/04 14:58:32 -->
<!-- 创建人：Zhao bing bing -->
<!-- 组件描述： -->
<template>
  <div class="yxtbiz-flex-center">
    <template v-if="hours">
      <yxt-select class="yxtbiz-w70 mr8" v-model="h">
        <yxt-option :value="0" label="00"/>
        <yxt-option v-for="item in hours" :value="item" :key="item" :label="item > 9 ? item : '0'+item"/>
      </yxt-select>
    <span class="mr12">{{ $t('pc_kng_detail_lbl_hour'/** 小时 */) }}</span>
    </template>
    <yxt-select class="yxtbiz-w70 mr8" v-model="m">
      <yxt-option :value="0" label="00"/>
      <yxt-option v-for="item in minutes" :value="item" :key="item" :label="item > 9 ? item : '0'+item"/>
    </yxt-select>{{ $t('pc_kng_detail_lbl_minute'/** 分钟 */) }}
    <yxt-select class="yxtbiz-w70 ml12 mr8" v-model="s">
      <yxt-option :value="0" label="00"/>
      <yxt-option v-for="item in seconds" :value="item" :key="item" :label="item > 9 ? item : '0'+item"/>
    </yxt-select>{{ $t('pc_kng_detail_lbl_second'/** 秒 */) }}
    <yxt-button v-if="!insertHidden" class="ml12" :disabled="insertDisabled" @click="insertCurrent">{{ $t('pc_biz_btn_insertcurrenttime'/** 插入当前时间 */) }}</yxt-button>
  </div>
</template>
<script>
export default {
  name: 'form-point-time',
  inject: ['getLoc', 'getDuration'],
  props: {
    value: {
      type: Number,
      default: 0
    },
    insertDisabled: {
      type: Boolean,
      default: false
    },
    insertHidden: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {};
  },
  computed: {
    duration() {
      return this.getDuration();
    },
    h: {
      get() {
        return Math.floor(this.value / 60 / 60);
      },
      set(val) {
        const time = val * 60 * 60 + this.m * 60 + this.s;
        this.$emit('input', Math.min(time, this.duration));
      }
    },
    m: {
      get() {
        return Math.floor((this.value - this.h * 60 * 60) / 60);
      },
      set(val) {
        const time = this.h * 60 * 60 + val * 60 + this.s;
        this.$emit('input', Math.min(time, this.duration));
      }
    },
    s: {
      get() {
        return Math.floor(this.value - this.h * 60 * 60 - this.m * 60);
      },
      set(val) {
        const time = this.h * 60 * 60 + this.m * 60 + val;
        this.$emit('input', Math.min(time, this.duration));
      }
    },
    hours() {
      return Math.floor(this.duration / 60 / 60);
    },
    minutes() {
      const minutes = Math.floor((this.duration - this.h * 60 * 60) / 60);
      return Math.min(59, minutes);
    },
    seconds() {
      const seconds = Math.floor(this.duration - this.h * 60 * 60 - this.m * 60);
      return Math.min(59, seconds);
    }
  },
  methods: {
    insertCurrent() {
      this.$emit('input', this.getLoc());
    }
  }
};
</script>